import { i18n } from 'i18n'

function register(doUnsavedChangesExistFn) {
  function checkUnsavedChangesOnPageUnload(e) {
    if (doUnsavedChangesExistFn()) {
      e.returnValue = i18n.t('UNSAVED_CHANGES')
      return i18n.t('UNSAVED_CHANGES')
    }
    return ''
  }

  window.addEventListener('beforeunload', checkUnsavedChangesOnPageUnload)

  return function unregister() {
    window.removeEventListener('beforeunload', checkUnsavedChangesOnPageUnload)
  }
}

// NOTE: Apply this mixin only to components that have 'entityId' in their route props
const mixin = {
  props: ['entityId'],
  computed: {
    isItemDirty() {
      return this.$store.state.saveStateDirty
    },
    checkingEnabled() {
      return !!this.entityId
    }
  },
  methods: {
    isOkToNavigate() {
      return !this.isItemDirty || window.confirm(i18n.t('UNSAVED_CHANGES'))
    },

    idFromRoute(route) {
      const routeRecord = _.find(
        route.matched,
        m => m.components.default.name === this.$options.name
      )
      if (routeRecord && routeRecord.props && _.isFunction(routeRecord.props.default))
        return routeRecord.props.default(route).entityId
      return null
    },

    hookBrowserNav() {
      if (this.checkingEnabled && !this.unsavedCheckerUnregister)
        this.unsavedCheckerUnregister = register(() => this.isItemDirty)
    },

    unhookBrowserNav() {
      if (_.isFunction(this.unsavedCheckerUnregister)) this.unsavedCheckerUnregister()
    }
  },

  beforeRouteUpdate(to, from, next) {
    const toId = this.idFromRoute(to)
    const fromId = this.entityId
    if (!this.checkingEnabled || toId == null) {
      next()
      return
    }
    if (toId === fromId || this.isOkToNavigate()) {
      next()
    } else {
      // We navigated to another entity and the user didn't want to discard their changes
      next(false)
    }
  },

  beforeRouteLeave(to, from, next) {
    if (!this.checkingEnabled || this.isOkToNavigate()) {
      next()
    } else {
      next(false)
    }
  },

  mounted() {
    this.hookBrowserNav()
  },

  beforeDestroy() {
    this.unhookBrowserNav()
  },

  watch: {
    checkingEnabled(newVal, oldVal) {
      if (newVal === oldVal) return
      if (newVal) this.hookBrowserNav()
      else this.unhookBrowserNav()
    }
  }
}

export default {
  mixin
}
